var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronBottom = function SvgChevronBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.727 8.48004C18.3478 8.07852 17.7149 8.06043 17.3134 8.43965L12 13.4578L6.68662 8.43965C6.2851 8.06043 5.6522 8.07852 5.27299 8.48004C4.89377 8.88155 4.91186 9.51446 5.31337 9.89367L11.3134 15.5603C11.6988 15.9243 12.3012 15.9243 12.6866 15.5603L18.6866 9.89367C19.0881 9.51446 19.1062 8.88155 18.727 8.48004Z",
    fill: "var(--on-surface)",
    fillOpacity: 0.95
  })));
};
export default SvgChevronBottom;